import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import qs from 'qs'
// import faker from 'faker'

import { defaultInstance } from 'services'

// import { randomNumberBetween, randomArray } from 'utils'
import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

const getStatuses = () => {
  return [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ]
}

const statuses = getStatuses()

const getStatusByValue = (value) => {
  return _.find(statuses, { value })
}

const mapFieldSection = (item, index) => {
  // const id = faker.datatype.uuid()
  // const abbrs = ['None', 'CFO']
  // return {
  //   key: id,
  //   id,
  //   code: _.padStart(randomNumberBetween(1, 9999), 8, '0'),
  //   abbr: randomArray(abbrs),
  //   name: faker.company.companyName(),
  //   status: randomArray(statuses),
  // }

  const id = item?.section_id
  return {
    index,
    key: uuidv4(),
    id,
    code: item?.section_cd,
    abbr: item?.section_abbr,
    name: item?.section_name,
    status: getStatusByValue(item?.is_pool),
  }
}

// const mockSections = (length = 10) => Array.from({ length }, mapFieldSection)

const mapFieldDepartment = (item, index) => {
  // const id = faker.datatype.uuid()
  // const abbrs = ['None', 'CFO']
  // return {
  //   key: id,
  //   id,
  //   code: _.padStart(randomNumberBetween(1, 9999), 8, '0'),
  //   abbr: randomArray(abbrs),
  //   name: faker.company.companyName(),
  //   status: randomArray(statuses),
  //   sections: mockSections(3),
  // }

  const id = item?.department_id
  return {
    index,
    key: uuidv4(),
    id,
    code: item?.department_cd,
    abbr: item?.department_abbr,
    name: item?.depart_name,
    status: getStatusByValue(item?.is_pool),
    sections: _.map(item?.section, mapFieldSection),
  }
}

// const mockDepartments = (length = 10) => Array.from({ length }, mapFieldDepartment)

const mapFieldDivision = (item, index) => {
  // const id = faker.datatype.uuid()
  // const abbrs = ['None', 'CFO']
  // return {
  //   key: id,
  //   id,
  //   code: _.padStart(randomNumberBetween(1, 9999), 8, '0'),
  //   abbr: randomArray(abbrs),
  //   name: faker.company.companyName(),
  //   status: randomArray(statuses),
  //   departments: mockDepartments(3),
  // }

  const id = item?.division_id
  return {
    index,
    key: uuidv4(),
    id,
    code: item?.division_cd,
    abbr: item?.division_abbr,
    name: item?.division_name,
    status: getStatusByValue(item?.is_pool),
    departments: _.map(item?.department, mapFieldDepartment),
  }
}

// const mockDivisions = (length = 10) => Array.from({ length }, mapFieldDivision)

const mapFieldBU = (item, index) => {
  // const id = faker.datatype.uuid()
  // const abbrs = ['None', 'AC', 'CF']
  // return {
  //   key: id,
  //   id,
  //   code: _.padStart(randomNumberBetween(1, 9999), 8, '0'),
  //   abbr: randomArray(abbrs),
  //   name: faker.company.companyName(),
  //   status: randomArray(statuses),
  //   divisions: mockDivisions(3),
  // }

  const id = item?.bu_id
  return {
    index,
    key: uuidv4(),
    id,
    code: item?.bu_cd,
    abbr: item?.bu_abbr,
    name: item?.bu_name,
    status: getStatusByValue(item?.is_pool),
    divisions: _.map(item?.division, mapFieldDivision),
  }
}

// const mockBUs = (length = 10) => Array.from({ length }, mapFieldBU)

const mapFieldGroup = (item, index) => {
  // const id = faker.datatype.uuid()
  // const abbrs = ['None', 'CFO', 'CHO', 'CMO', 'CPO', 'MDCD', 'MDSDH', 'MDTH']
  // return {
  //   key: id,
  //   id,
  //   code: _.padStart(randomNumberBetween(1, 9999), 8, '0'),
  //   abbr: randomArray(abbrs),
  //   name: faker.company.companyName(),
  //   status: randomArray(statuses),
  //   bus: mockBUs(3),
  // }

  const id = item?.group_id
  return {
    index,
    key: uuidv4(),
    id,
    code: item?.group_cd,
    abbr: item?.group_abbr,
    name: item?.group_name,
    status: getStatusByValue(item?.is_pool),
    bus: _.map(item?.business_unit, mapFieldBU),
  }
}

// const mockGroups = (length = 10) => Array.from({ length }, mapFieldGroup)

export const mapFieldOrganization = (item, index) => {
  // const id = faker.datatype.uuid()
  // const abbrs = ['KS', 'IN', 'PS CEO', 'PSH']
  // return {
  //   key: id,
  //   id,
  //   code: _.padStart(randomNumberBetween(1, 9999), 8, '0'),
  //   abbr: randomArray(abbrs),
  //   name: faker.company.companyName(),
  //   status: randomArray(statuses),
  //   groups: mockGroups(5),
  // }

  const id = item?.company_id
  return {
    index,
    key: uuidv4(),
    id,
    code: item?.company_cd,
    abbr: item?.company_abbr,
    name: item?.company_name,
    status: getStatusByValue(item?.is_pool),
    groups: _.map(item?.group, mapFieldGroup),
  }
}

// const mockOrganizations = (length = 10) => Array.from({ length }, mapFieldOrganization)

export const getOrganizationListApi = ({
  company_id,
  group_id,
  bu_id,
  division_id,
  department_id,
  section_id,
  is_active,
  org_with_risk_co,
}) => {
  const params = removeEmpty({
    company_id,
    group_id,
    bu_id,
    division_id,
    department_id,
    section_id,
    is_active,
    org_with_risk_co,
  })

  const config = {
    method: 'get',
    url: '/api/v1/organization/',
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapFieldOrganization) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateOrganizationByIdApi = ({ level, id, is_pool }) => {
  const data = {
    level,
    id,
    is_pool,
  }

  const config = {
    method: 'patch',
    url: '/api/v1/organization/',
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
